export default function createFilter(rawFilter) {
  if (!rawFilter) {
    return {
      matches() {
        return true
      },
    }
  }
  const filter = rawFilter.toLowerCase()
  return {
    matches(str) {
      return str.toLowerCase().includes(filter)
    },
  }
}
